import { ChartColors } from '@/models/common/ChartColors';
import { SysarbColors } from '@/types';
import type { Options, ShadowOptionsObject } from 'highcharts';
import { i18n } from '@/i18n';
import { tooltipCallbackFunc } from '@/common/chartHelper/ChartFunctions';

const tooltipShadow: ShadowOptionsObject = {
    color: 'fefefe',
    offsetX: 0,
    offsetY: 0,
    opacity: 0.035,
    width: 8
};

export const defaultOptions: Options = {
    chart: {
        styledMode: false,
        style: {
            fontFamily: 'Aeonik Pro, Open Sans, Arial, sans-serif',
        },
        backgroundColor: 'transparent',
        resetZoomButton: {
            theme: {
                style: {
                    height: 0,
                    opacity: 0
                }
            }
        },
        zooming: {
            type: 'x'
        },
    },
    boost: {
        enabled: false,
    },
    colors: ChartColors,
    lang: {
        noData: i18n.global.t('system.noData'),
    },
    noData: {
        style: {
            whiteSpace: 'wrap'
        }
    },
    yAxis: {
        labels: {
            enabled: true,
            format: '{value:,.0f}',
            style: {
                fontSize: '0.75rem',
                whiteSpace: 'wrap',
            },
        },
        title: {
            text: undefined
        },
    },
    xAxis: {
        labels: {
            style: {
                fontSize: '0.75rem',
                whiteSpace: 'wrap',
            },
            useHTML: true,
        },
        tickmarkPlacement: 'between'
    },
    plotOptions: {
        series: {
            turboThreshold: 20000,
            stickyTracking: false,
            cursor: 'pointer',
        },
        column: {
            dataLabels: {
                enabled: false
            },
        },
        pie: {
            borderRadius: 0,
            dataLabels: {
                enabled: false
            },
        },
        boxplot: {
            grouping: false,
            stacking: 'normal',
            lineWidth: 0,
            stemWidth: 1,
            whiskerWidth: 1,
            medianWidth: 1,
            centerInCategory: true,
            pointPadding: 0,
            groupPadding: 0.1,
        },
        scatter: {
            animationLimit: 1000
        }
    },
    tooltip: {
        enabled: true,
        borderRadius: 12,
        borderColor: 'none',
        snap: 10,
        hideDelay: 0,
        backgroundColor: SysarbColors.WHITE,
        formatter: tooltipCallbackFunc(),
        outside: true,
        useHTML: true,
        shadow: tooltipShadow
    },
    legend: {
        itemStyle: {
            fontSize: '12px',
            fontWeight: '400',
        },
        navigation: {
            activeColor: SysarbColors.BLUE_600,
        },
        itemMarginBottom: 8,
    },
    credits: {
        enabled: false
    },
    exporting: {
        buttons: {
            contextButton: {
                enabled: false
            }
        },
    },
    responsive: {
        rules: [{
            condition: {
                maxWidth: 400
            },
            // Remove legends if chart is less than 400px in width
            chartOptions: {
                legend: {
                    enabled: false,
                }
            }
        }]
    },
    title: {
        text: ''
    }
};
